import axios from '~/utils/axios';

import { Account } from '~/types';

export type GetPnlAccountsParams = {
  regulatoryType?: string | string[];
  glType?: string | string[];
};

export const getPnlAccounts = (params?: GetPnlAccountsParams) => {
  return axios.get<Account[]>(`tenant/accounts`, {
    params: { page: 1, perPage: 9999, ...params },
  });
};
